import { Grid, Paper } from "@mui/material";
import React from "react";
import { styled } from "@mui/material/styles";
import { GRAY, WHITE } from "../colors";
import InquiryForm from "../containers/Forms/InquiryForm";
import ChatBox from "../containers/chatBox/ChatBox";
import DepartmentsForm from "../containers/Forms/DepartmentsForm";
import DesignationForm from "../containers/Forms/DesignationForm";
import InquiryTypeForm from "../containers/Forms/InquiryTypeForm";
import Options from "./OptionsManage"

const Container = styled(Paper)(({ theme }) => ({
  backgroundColor: "#D9D9D9",
  borderRadius: 10,
  padding: 10,
  textAlign: "center",
  padding: "20px 40px",
  overflowY: "scroll",
}));
const SystemConfigs = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <Container elevation={0}>
          <DepartmentsForm />
        </Container>
      </Grid>
      <Grid item xs={6}>
        <Container elevation={0}>
          <DesignationForm />
        </Container>
      </Grid>
      <Grid item xs={6}>
        <Container elevation={0}>
          <InquiryTypeForm />
        </Container>
      </Grid>
      <Grid item xs={12}>
        <Options />
      </Grid>
    </Grid>
  );
};

export default SystemConfigs;
